import { Skeleton, Box } from '@mui/material';

export const MediaDialogSkeleton = () => {
    return (
        <Box sx={{ p: 2 }}>
            {/* Header with upload button */}
            <Box sx={{ mb: 12, display: 'flex', justifyContent: 'flex-end' }}>
                <Skeleton variant="rounded" width='100%' height={100} />
            </Box>

            {/* Grid of media items */}
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 2 }}>
                {Array.from({ length: 16 }).map((_, index) => (
                    <Box key={index}>
                        <Skeleton variant="rounded" width={275} height={250} sx={{ mb: 1 }} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};